"use client";

export { useToast, toast } from "@/components/ui/use-toast";
